(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["home-sec3"] && !Shopify.designMode) return;
  try {
    
  var inputVal = '';

  document.getElementById('homereg').addEventListener('focus', function (e) {
    e.target.value = '';
  });

  document.getElementById('homereg').addEventListener('keyup', function (e) {
    inputVal = e.target.value;
  });

  document.querySelector('.home_bg_footer').addEventListener('click', function () {
    localStorage.setItem('reg', inputVal);
    window.location.href = 'https://mydevelopement.myshopify.com/products/gel-4d-size';
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["plate-FQA"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('.question').forEach(function (question) {
    question.addEventListener('click', function () {
      this.classList.toggle('active');
      document.querySelectorAll('.question').forEach(function (otherQuestion) {
        if (otherQuestion !== question) {
          otherQuestion.style.display = 'block';
        }
      });
      this.nextElementSibling.style.display = 'block';
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-recommendations"]) return;
  try {
    
  class ProductRecommendations extends HTMLElement {
    constructor() {
      super();

      const handleIntersection = (entries, observer) => {
        if (!entries[0].isIntersecting) return;
        observer.unobserve(this);

        fetch(this.dataset.url)
          .then(response => response.text())
          .then(text => {
            const html = document.createElement('div');
            html.innerHTML = text;
            const recommendations = html.querySelector('product-recommendations');

            if (recommendations && recommendations.innerHTML.trim().length) {
              this.innerHTML = recommendations.innerHTML;
            }

            if (html.querySelector('.grid__item')) {
              this.classList.add('product-recommendations--loaded');
            }
          })
          .catch(e => {
            console.error(e);
          });
      }

      new IntersectionObserver(handleIntersection.bind(this), {rootMargin: '0px 0px 200px 0px'}).observe(this);
    }
  }

  customElements.define('product-recommendations', ProductRecommendations);

  } catch(e) { console.error(e); }
})();
})();
